import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-gray-900" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "p-6 space-y-6" }
const _hoisted_4 = { class: "p-6" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { value: "" }
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "mt-4 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_11 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "p-12 flex items-center justify-center"
}
const _hoisted_14 = { class: "flex items-center gap-3" }
const _hoisted_15 = {
  key: 1,
  class: "p-8 text-center"
}
const _hoisted_16 = { class: "text-red-600 dark:text-red-400" }
const _hoisted_17 = {
  key: 2,
  class: "overflow-x-auto"
}
const _hoisted_18 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_19 = { class: "px-6 py-4" }
const _hoisted_20 = { class: "flex flex-wrap gap-1.5" }
const _hoisted_21 = {
  key: 0,
  class: "text-green-500"
}
const _hoisted_22 = {
  key: 1,
  class: "text-amber-500"
}
const _hoisted_23 = { class: "px-6 py-4 text-center" }
const _hoisted_24 = {
  key: 3,
  class: "p-12 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        _ctx.theme.isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
        'border-b px-6 py-4'
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", {
            class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900', 'text-2xl font-bold'])
          }, " Firestore Index Usage ", 2),
          _createElementVNode("p", {
            class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600', 'mt-1 text-sm'])
          }, " Monitor composite index usage across databases and collections ", 2)
        ]),
        _createVNode(_component_router_link, {
          to: "/database",
          class: _normalizeClass([
            _ctx.theme.isDark.value
              ? 'text-gray-400 hover:text-gray-200'
              : 'text-gray-600 hover:text-gray-900',
            'text-sm font-medium'
          ])
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode(" ← Back to Database ")
          ])),
          _: 1,
          __: [8]
        }, 8, ["class"])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass([
          _ctx.theme.isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg overflow-hidden'
        ])
      }, [
        _createElementVNode("h2", {
          class: _normalizeClass([
            _ctx.theme.isDark.value ? 'text-gray-100 border-gray-700' : 'text-gray-900 border-gray-200',
            'text-lg font-semibold px-6 py-4 border-b'
          ])
        }, " Select Collection ", 2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("label", {
                for: "firestore-env-select",
                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                  'block text-sm font-medium mb-2'
                ])
              }, " Environment ", 2),
              _withDirectives(_createElementVNode("select", {
                id: "firestore-env-select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firestoreEnv) = $event)),
                class: _normalizeClass([
                  _ctx.theme.isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-100'
                    : 'bg-white border-gray-300 text-gray-900',
                  'w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500'
                ]),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onEnvChange && _ctx.onEnvChange(...args)))
              }, _cache[9] || (_cache[9] = [
                _createElementVNode("option", { value: "staging" }, "Staging", -1),
                _createElementVNode("option", { value: "production" }, "Production", -1)
              ]), 34), [
                [_vModelSelect, _ctx.firestoreEnv]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", {
                for: "firestore-db-select",
                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                  'block text-sm font-medium mb-2'
                ])
              }, " Database ", 2),
              _withDirectives(_createElementVNode("select", {
                id: "firestore-db-select",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDatabase) = $event)),
                class: _normalizeClass([
                  _ctx.theme.isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-100'
                    : 'bg-white border-gray-300 text-gray-900',
                  'w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50'
                ])
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, "Select a database", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.databases, (db) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: db,
                    value: db
                  }, _toDisplayString(db), 9, _hoisted_6))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.selectedDatabase]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", {
                for: "firestore-collection-select",
                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                  'block text-sm font-medium mb-2'
                ])
              }, " Collection (Kind) ", 2),
              _withDirectives(_createElementVNode("select", {
                id: "firestore-collection-select",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedKind) = $event)),
                disabled: _ctx.kindsLoading || _ctx.kinds.length === 0,
                class: _normalizeClass([
                  _ctx.theme.isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-100'
                    : 'bg-white border-gray-300 text-gray-900',
                  'w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50'
                ])
              }, [
                _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.kindsLoading
                      ? 'Loading...'
                      : _ctx.selectedDatabase
                        ? 'Select a collection'
                        : 'Select database first'), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kinds, (kind) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: kind,
                    value: kind
                  }, _toDisplayString(kind), 9, _hoisted_9))
                }), 128))
              ], 10, _hoisted_7), [
                [_vModelSelect, _ctx.selectedKind]
              ])
            ])
          ]),
          (_ctx.kindsError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.kindsError), 1))
            : _createCommentVNode("", true)
        ])
      ], 2),
      (_ctx.selectedKind)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([
          _ctx.theme.isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg overflow-hidden'
        ])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([
            _ctx.theme.isDark.value ? 'border-gray-700' : 'border-gray-200',
            'px-6 py-4 border-b flex flex-col md:flex-row md:items-center md:justify-between gap-4'
          ])
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", {
                  class: _normalizeClass([
                _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
                'text-lg font-semibold'
              ])
                }, " Composite Index Usage ", 2),
                _createElementVNode("p", {
                  class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600', 'text-sm mt-1'])
                }, _toDisplayString(_ctx.selectedDatabase) + " / " + _toDisplayString(_ctx.selectedKind), 3)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", {
                  class: _normalizeClass([
                _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                'flex items-center gap-2 text-sm cursor-pointer'
              ])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showOnlyUnused) = $event)),
                    type: "checkbox",
                    class: "rounded border-gray-300 text-amber-600 focus:ring-amber-500"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.showOnlyUnused]
                  ]),
                  _cache[11] || (_cache[11] = _createTextVNode(" Unused only "))
                ], 2),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sortBy) = $event)),
                  class: _normalizeClass([
                _ctx.theme.isDark.value
                  ? 'bg-gray-700 border-gray-600 text-gray-100'
                  : 'bg-white border-gray-300 text-gray-900',
                'rounded-md border px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500'
              ])
                }, _cache[12] || (_cache[12] = [
                  _createElementVNode("option", { value: "lastUsed-desc" }, "Last Used (Recent)", -1),
                  _createElementVNode("option", { value: "lastUsed-asc" }, "Last Used (Oldest)", -1),
                  _createElementVNode("option", { value: "id-asc" }, "ID (A-Z)", -1),
                  _createElementVNode("option", { value: "id-desc" }, "ID (Z-A)", -1)
                ]), 2), [
                  [_vModelSelect, _ctx.sortBy]
                ]),
                _createElementVNode("button", {
                  disabled: _ctx.indexUsageLoading,
                  class: _normalizeClass([
                _ctx.theme.isDark.value
                  ? 'bg-blue-600 hover:bg-blue-700 text-white'
                  : 'bg-blue-600 hover:bg-blue-700 text-white',
                'px-4 py-1.5 rounded-md text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
              ]),
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.loadIndexUsage && _ctx.loadIndexUsage(...args)))
                }, _toDisplayString(_ctx.indexUsageLoading ? 'Loading...' : 'Refresh'), 11, _hoisted_12)
              ])
            ], 2),
            (_ctx.indexUsageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[13] || (_cache[13] = _createElementVNode("svg", {
                      class: "animate-spin h-5 w-5 text-blue-500",
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      })
                    ], -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600')
                    }, " Loading index usage data... ", 2)
                  ])
                ]))
              : (_ctx.indexUsageError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.indexUsageError), 1),
                    _createElementVNode("button", {
                      class: "mt-4 px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.loadIndexUsage && _ctx.loadIndexUsage(...args)))
                    }, " Retry ")
                  ]))
                : (_ctx.filteredIndexStats.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
              _ctx.theme.isDark.value ? 'bg-gray-700/30 border-gray-700' : 'bg-gray-50 border-gray-200',
              'px-6 py-3 border-b grid grid-cols-2 md:grid-cols-4 gap-4'
            ])
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                  'text-xs uppercase tracking-wider'
                ])
                          }, " Total Indexes ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
                  'text-xl font-semibold mt-1'
                ])
                          }, _toDisplayString(_ctx.indexUsageData?.summary.total || 0), 3)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-green-400' : 'text-green-600',
                  'text-xs uppercase tracking-wider'
                ])
                          }, " Used ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-green-300' : 'text-green-700',
                  'text-xl font-semibold mt-1'
                ])
                          }, _toDisplayString(_ctx.indexUsageData?.summary.used || 0), 3)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-amber-400' : 'text-amber-600',
                  'text-xs uppercase tracking-wider'
                ])
                          }, " Unused ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  (_ctx.indexUsageData?.summary?.unused ?? 0) > 0
                    ? 'text-amber-500'
                    : _ctx.theme.isDark.value
                      ? 'text-gray-100'
                      : 'text-gray-900',
                  'text-xl font-semibold mt-1'
                ])
                          }, _toDisplayString(_ctx.indexUsageData?.summary.unused || 0), 3)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                  'text-xs uppercase tracking-wider'
                ])
                          }, " Showing ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
                  'text-xl font-semibold mt-1'
                ])
                          }, _toDisplayString(_ctx.filteredIndexStats.length), 3)
                        ])
                      ], 2),
                      _createElementVNode("table", _hoisted_18, [
                        _createElementVNode("thead", {
                          class: _normalizeClass([
                _ctx.theme.isDark.value ? 'bg-gray-700/50' : 'bg-gray-50',
                'text-left text-xs font-medium uppercase tracking-wider'
              ])
                        }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600', 'px-6 py-3'])
                            }, " Index ID ", 2),
                            _createElementVNode("th", {
                              class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600', 'px-6 py-3'])
                            }, " Fields ", 2),
                            _createElementVNode("th", {
                              class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600', 'px-6 py-3'])
                            }, " Query Scope ", 2),
                            _createElementVNode("th", {
                              class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600', 'px-6 py-3'])
                            }, " Last Used ", 2),
                            _createElementVNode("th", {
                              class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600', 'px-6 py-3'])
                            }, " Tracked Since ", 2),
                            _createElementVNode("th", {
                              class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600',
                    'px-6 py-3 text-center'
                  ])
                            }, " Status ", 2)
                          ])
                        ], 2),
                        _createElementVNode("tbody", {
                          class: _normalizeClass([_ctx.theme.isDark.value ? 'divide-gray-700' : 'divide-gray-200', 'divide-y'])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredIndexStats, (idx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: idx.indexId,
                              class: _normalizeClass([
                  _ctx.theme.isDark.value
                    ? 'bg-gray-800 hover:bg-gray-700/50'
                    : 'bg-white hover:bg-gray-50'
                ])
                            }, [
                              _createElementVNode("td", {
                                class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600',
                    'px-6 py-4 text-sm font-mono'
                  ])
                              }, _toDisplayString(idx.alphanumericId), 3),
                              _createElementVNode("td", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(idx.properties, (prop, propIdx) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: propIdx,
                                      class: _normalizeClass([
                        _ctx.theme.isDark.value
                          ? 'bg-gray-700 text-gray-200'
                          : 'bg-gray-100 text-gray-800',
                        'inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium'
                      ])
                                    }, [
                                      (prop.direction === 'ASCENDING')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, "↑"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_22, "↓")),
                                      _createTextVNode(" " + _toDisplayString(prop.name), 1)
                                    ], 2))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("td", {
                                class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                    'px-6 py-4 text-sm'
                  ])
                              }, _toDisplayString(idx.ancestor === 'COLLECTION' ? 'Collection' : 'Collection Group'), 3),
                              _createElementVNode("td", {
                                class: _normalizeClass([
                    idx.lastKnownUsageTime
                      ? _ctx.theme.isDark.value
                        ? 'text-gray-300'
                        : 'text-gray-600'
                      : 'text-amber-500',
                    'px-6 py-4 text-sm'
                  ])
                              }, _toDisplayString(idx.lastKnownUsageTime ? _ctx.formatDate(idx.lastKnownUsageTime) : 'Never used'), 3),
                              _createElementVNode("td", {
                                class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                    'px-6 py-4 text-sm'
                  ])
                              }, _toDisplayString(_ctx.formatDate(idx.statTrackedSinceTime)), 3),
                              _createElementVNode("td", _hoisted_23, [
                                (!idx.lastKnownUsageTime)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass([
                      _ctx.theme.isDark.value
                        ? 'bg-amber-900/50 text-amber-300'
                        : 'bg-amber-100 text-amber-800',
                      'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium'
                    ])
                                    }, " Unused ", 2))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: _normalizeClass([
                      _ctx.theme.isDark.value
                        ? 'bg-green-900/50 text-green-300'
                        : 'bg-green-100 text-green-800',
                      'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium'
                    ])
                                    }, " Active ", 2))
                              ])
                            ], 2))
                          }), 128))
                        ], 2)
                      ])
                    ]))
                  : (!_ctx.indexUsageLoading && !_ctx.indexUsageError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (_openBlock(), _createElementBlock("svg", {
                          class: _normalizeClass([
              _ctx.theme.isDark.value ? 'text-gray-600' : 'text-gray-400',
              'w-12 h-12 mx-auto mb-4'
            ]),
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, _cache[14] || (_cache[14] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          }, null, -1)
                        ]), 2)),
                        _createElementVNode("p", {
                          class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600', 'text-sm'])
                        }, _toDisplayString(_ctx.showOnlyUnused
                ? 'No unused indexes found'
                : 'No composite indexes found for this collection'), 3)
                      ]))
                    : _createCommentVNode("", true)
          ], 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([
          _ctx.theme.isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg p-12 text-center'
        ])
          }, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([
            _ctx.theme.isDark.value ? 'text-gray-600' : 'text-gray-400',
            'w-16 h-16 mx-auto mb-4'
          ]),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, _cache[15] || (_cache[15] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4"
              }, null, -1)
            ]), 2)),
            _createElementVNode("h3", {
              class: _normalizeClass([
            _ctx.theme.isDark.value ? 'text-gray-200' : 'text-gray-900',
            'text-lg font-medium mb-2'
          ])
            }, " Select a Collection ", 2),
            _createElementVNode("p", {
              class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600', 'text-sm'])
            }, " Choose an environment, database, and collection above to view composite index usage. ", 2)
          ], 2))
    ])
  ]))
}